import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { LimitedFilteredRequest } from './FilteredRequest.js';
export var ExcelExportType;
(function (ExcelExportType) {
    ExcelExportType["Payments"] = "payments";
    ExcelExportType["Members"] = "members";
    ExcelExportType["Registrations"] = "registrations";
    ExcelExportType["Organizations"] = "organizations";
    ExcelExportType["ReceivableBalances"] = "receivable-balances";
    ExcelExportType["EventNotifications"] = "event-notifications";
    ExcelExportType["BalanceItems"] = "BalanceItems";
    ExcelExportType["PlatformMemberships"] = "platform-memberships";
})(ExcelExportType || (ExcelExportType = {}));
export class ExcelSheetColumnFilter extends AutoEncoder {
    id;
    name;
    category = null;
}
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetColumnFilter.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetColumnFilter.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], ExcelSheetColumnFilter.prototype, "category", void 0);
export class ExcelSheetFilter extends AutoEncoder {
    id;
    name = '';
    columns = [];
}
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetFilter.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 345 })
], ExcelSheetFilter.prototype, "name", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(ExcelSheetColumnFilter), version: 345, upgrade: (old) => old.map(id => ExcelSheetColumnFilter.create({ id, name: '' })) }),
    field({ decoder: new ArrayDecoder(StringDecoder) })
], ExcelSheetFilter.prototype, "columns", void 0);
/**
 * Which sheets and columns to include in the excel file
 */
export class ExcelWorkbookFilter extends AutoEncoder {
    sheets = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(ExcelSheetFilter) })
], ExcelWorkbookFilter.prototype, "sheets", void 0);
export class ExcelExportRequest extends AutoEncoder {
    filter;
    workbookFilter;
    /**
     * File name to use for the excel file, without extension.
     */
    title = null;
}
__decorate([
    field({ decoder: LimitedFilteredRequest })
], ExcelExportRequest.prototype, "filter", void 0);
__decorate([
    field({ decoder: ExcelWorkbookFilter })
], ExcelExportRequest.prototype, "workbookFilter", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, ...NextVersion })
], ExcelExportRequest.prototype, "title", void 0);
export class ExcelExportResponse extends AutoEncoder {
    /**
     * Contains a file id which can be used to download the file
     *
     * If this is null, the file will be sent via e-mail
     */
    url = null;
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ExcelExportResponse.prototype, "url", void 0);
//# sourceMappingURL=ExcelExportRequest.js.map